import { render } from "./TheDeviceConfigurationsGenerals.vue?vue&type=template&id=6be76424"
import script from "./TheDeviceConfigurationsGenerals.vue?vue&type=script&lang=js"
export * from "./TheDeviceConfigurationsGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__